import React, { FunctionComponent, SVGProps } from 'react'

export const IconArrowUp: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    stroke="#FCFCFC"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 17.4408V4.60742"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58594 11.0241L11.0026 4.60742L17.4193 11.0241"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
